// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import 'owl.carousel2/dist/owl.carousel.min';

// base package
// Import fontawesome
// import fontawesome from '@fortawesome/fontawesome';
/*import 'owl.carousel/dist/owl.carousel.min';*/

// add icon
// import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebookF';
// import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
// import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';
// import faenvelope from '@fortawesome/fontawesome-free-solid/faEnvelope';
// import faYoutube from '@fortawesome/fontawesome-free-brands/faYoutube'
// import fasshare from '@fortawesome/fontawesome-free-solid/faShareAlt'

// add the imported icons to the library
// fontawesome.library.add(faFacebook, faTwitter, faInstagram, faenvelope, faYoutube, fasshare);

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js